import { FC } from 'react'
import Image from '@components/ui/image'
import { IoHeartOutline, IoHeartSharp } from 'react-icons/io5'
import { ImSpinner2 } from 'react-icons/im'

interface CarouselActionsProps {
  data: {
    icon: string
    onClick: () => void
    key: string
  }
  index: number
  wishListAdded: boolean
  whishListLoading: boolean
}

const CarouselActions: FC<CarouselActionsProps> = ({
  data,
  index,
  wishListAdded,
  whishListLoading,
}) => {
  const { icon, onClick, key } = data
  const hideZoomClass = index === 0 ? 'md:hidden' : ''
  const circleClass =
    'border bg-white rounded-full w-full h-11 flex items-center justify-center'

  const handleClick =
    (key === 'wishlist' && wishListAdded) || whishListLoading
      ? undefined
      : onClick

  return (
    <div
      onClick={handleClick}
      className={`flex items-center m-2 ${hideZoomClass}`}
    >
      {key !== 'wishlist' ? (
        <Image src={icon} alt="custom-quote-icon" width={45} height={45} />
      ) : (
        <p className={circleClass}>
          {whishListLoading ? (
            <ImSpinner2 className="w-5 h-5 animate-spin pointer-events-none" />
          ) : wishListAdded ? (
            <IoHeartSharp fontSize={25} className="text-brand" />
          ) : (
            <IoHeartOutline fontSize={25} />
          )}
        </p>
      )}
    </div>
  )
}

export default CarouselActions
